function absImage(value, baseUrl) {
  const image = String(value || "").trim();
  if (!image) return "";
  if (image.startsWith("http://") || image.startsWith("https://")) return image;
  return `${baseUrl}${image.startsWith("/") ? image : `/${image}`}`;
}

function baseGraph(config, seo, routePath) {
  return {
    "@context": "https://schema.org",
    "@id": `${seo.canonical}#${routePath || "page"}`,
    url: seo.canonical,
    name: seo.title,
    description: seo.description,
    inLanguage: "en",
  };
}

export function buildJsonLd(routeKey, entity = {}, seo, config) {
  const image = absImage(entity.image || entity.posterUrl || entity.avatarUrl || config.defaultImage, config.baseUrl);

  switch (routeKey) {
    case "home":
      return [
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: config.siteName,
          url: config.baseUrl,
          description: config.defaultDescription,
        },
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: config.brandName,
          url: config.baseUrl,
          logo: absImage(config.defaultImage, config.baseUrl),
        },
      ];

    case "profile":
      return {
        ...baseGraph(config, seo, "profile"),
        "@type": "ProfilePage",
        mainEntity: {
          "@type": "Person",
          name: entity.displayName || entity.userName || "Inssa Member",
          url: seo.canonical,
          image,
        },
      };

    case "business":
      return {
        ...baseGraph(config, seo, "business"),
        "@type": "LocalBusiness",
        image,
        address: entity.hqAddress
          ? {
              "@type": "PostalAddress",
              streetAddress: entity.hqAddress,
            }
          : undefined,
      };

    case "series":
      return {
        ...baseGraph(config, seo, "series"),
        "@type": "TVSeries",
        image,
      };

    case "video":
      return {
        ...baseGraph(config, seo, "video"),
        "@type": "VideoObject",
        thumbnailUrl: image || undefined,
        uploadDate: entity.publishedAt || entity.createdAt || undefined,
        duration: entity.duration || undefined,
      };

    case "raffle":
      return {
        ...baseGraph(config, seo, "raffle"),
        "@type": "Event",
        image,
        eventStatus: entity.closed ? "https://schema.org/EventCompleted" : "https://schema.org/EventScheduled",
      };

    case "capsule":
      return {
        ...baseGraph(config, seo, "capsule"),
        "@type": "Article",
        image,
        datePublished: entity.createdAt || undefined,
        dateModified: entity.updatedAt || undefined,
      };

    case "watch":
      return {
        ...baseGraph(config, seo, "watch"),
        "@type": "CollectionPage",
      };

    default:
      return null;
  }
}

